import { Reveal, SectionHeading } from "./Section";
import { GraduationCap, Wrench, Code2, PlaneTakeoff, Rocket } from "lucide-react";

const STEPS = [
  { years: "2012 — 2014", title: "DAV Public School", text: "The foundation years.", icon: GraduationCap },
  { years: "Graduation", title: "ITER, SOA University", text: "Institute of Technical Education & Research — where the first venture was born.", icon: GraduationCap },
  { years: "College Years", title: "Garage Verse", text: "A highway breakdown near Jagannath Puri became the first business idea — roadside assistance for people with nobody to call. The entrepreneurial journey had begun.", icon: Wrench, highlight: true },
  { years: "Professional", title: "Rubix Data Science", text: "Senior Software Engineer — technology, software engineering and professional problem-solving.", icon: Code2 },
  { years: "Global Scale", title: "S&P Global", text: "Senior Software Engineer — where technology, data and business intersect at global scale. The transition from technology professional to business builder.", icon: Code2 },
  { years: "Today", title: "Chairman & MD, Trackify Aero", text: "Building aviation technology, raising capital, signing airlines — and building what comes next.", icon: PlaneTakeoff, highlight: true },
  { years: "Next", title: "Search Fund & Beyond", text: "Searching for businesses, partners and opportunities where impact can compound.", icon: Rocket },
];

const Journey = () => (
  <section id="journey" className="relative py-28 md:py-36 bg-[#0C0F16]" data-testid="journey-section">
    <div className="mx-auto max-w-7xl px-5 md:px-8">
      <SectionHeading index="02" eyebrow="My Journey" title="From a college entrepreneur to building businesses across industries." />
      <div className="relative max-w-3xl">
        <div className="absolute left-[19px] top-2 bottom-2 w-px bg-gradient-to-b from-[#E2C08D]/60 via-white/10 to-transparent" />
        <div className="space-y-10">
          {STEPS.map((s, i) => (
            <Reveal key={s.title} delay={i * 0.06}>
              <div className="relative flex gap-6 pl-2" data-testid={`journey-step-${i}`}>
                <div className={`relative z-10 flex h-9 w-9 shrink-0 items-center justify-center rounded-full border ${s.highlight ? "border-[#E2C08D] bg-[#E2C08D]/15 text-[#E2C08D]" : "border-white/15 bg-[#12161f] text-slate-400"}`}>
                  <s.icon size={15} />
                </div>
                <div className="pb-1">
                  <span className="font-mono text-[11px] uppercase tracking-[0.25em] text-[#E2C08D]">{s.years}</span>
                  <h3 className="mt-1.5 font-display text-2xl font-semibold text-slate-100">{s.title}</h3>
                  <p className="mt-2 text-sm md:text-base text-slate-400 leading-relaxed max-w-xl">{s.text}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default Journey;
